import Header from "@/shared/Header";
import Footer from "@/shared/Footer";
import Analitics from "@/shared/Analitics";
import DfpService from "@/shared/DFP/Services";
import { sizeBanner } from "@/shared/DFP/Services/mapping";
import BannerFlotante from "@/widgets/Banner/Templates/BannerFlotante";
import Banner from "@/widgets/Banner/Templates/Banner";
import BannerLazy from "@/widgets/Banner/Templates/BannerLazy";
import SubHeadSectionBox from "@/shared/SubHeadSection";
import { ContainerAuto } from "@/shared/ContainerAuto";
import { ContainerServices, ServicesData } from "./style";
import { BannerSticky, BannerCajaGris } from "@/shared/ContentBanner";
import { BannerFlotante2 } from "@/shared/ContentBanner";
import LdjsonOrg from "@/shared/Schemas/Organization";
import LdjsonBreadcrumbList from "@/shared/Schemas/BreadcrumbList";
import LdjsonNewsMediaOrg from "@/shared/Schemas/NewsMediaOrganization";
import LdjsonWebsite from "@/shared/Schemas/Website";
import LdjsonItemList from "@/shared/Schemas/ItemList";
import LdjsonMonetaryAmount from "@/shared/Schemas/MonetaryAmount";
import ArticuloServiceLayout from "@/shared/Layout/ArticleServiceLayout";
import Breadcrumb from "@/shared/Breadcrumb";
import Meter from "@/shared/Meter/index.jsx";
import Autorefresh from "@/shared/Autorefresh";
import { ServiceHead } from "./components/ServiceHead";
import { ServiceLdjsonNewsArticle } from "./components/ServiceLdjsonNewsArticle";
import TemplateProvider from "@/context/Template/TemplateProvider.jsx";
import { useService } from "./hooks/useService";

const Service = (props) => {
  
  const { formatContent, ...rest } = useService(props);
  const ComponentTemplate = formatContent?.componentTemplate;

  return (
    <TemplateProvider data={{ ...rest, content: formatContent }} >
      <ServiceHead />
      <LdjsonOrg />
      <LdjsonBreadcrumbList />
      <LdjsonNewsMediaOrg />
      <LdjsonWebsite />
      <LdjsonItemList />
      {formatContent?.isHoroscope && <ServiceLdjsonNewsArticle />}
      {formatContent?.isEconomiaDivisas &&
        <LdjsonMonetaryAmount
          data={rest?.properties?.service?.data?.currency}
          usdBlueTourist={rest?.properties?.service?.data?.usdBlueTourist}
        />
      }
      <Analitics />
      {formatContent?.bannersOn && <DfpService />}
      {formatContent?.enableHeader && <Header />}
      <ContainerAuto className={`${formatContent?.width100 ? "container100" : ""}`}>
        {rest?.properties?.service?.titleHeader && <SubHeadSectionBox />}
        <Breadcrumb />
        <ContainerServices>
          <ServicesData
            widthFull={formatContent?.widthFull}
            enableHeader={formatContent?.enableHeader}
          >
            {!!ComponentTemplate && <ComponentTemplate />}
          </ServicesData>
          {!formatContent?.widthFull && (
            <div className="banners">
              <BannerCajaGris heightBanner="600px">
                <Banner slotId={"caja0"} />
              </BannerCajaGris>
              <BannerSticky heightBanner="300px">
                <Banner slotId={"caja1"} />
              </BannerSticky>
            </div>
          )}
        </ContainerServices>
      </ContainerAuto>
      <ArticuloServiceLayout />
      {formatContent?.bannersOn && (
        <>
          <BannerFlotante slotId={"1"} />
          <BannerFlotante slotId={"6"} />
          <BannerFlotante2>
            <BannerFlotante slotId={"2"} />
          </BannerFlotante2>
          <ContainerAuto>
            <BannerCajaGris>
              <BannerLazy
                slotId={"horizontal3"}
                adsPath={formatContent?.adsPath}
                mapping={sizeBanner.horizontal3}
              />
            </BannerCajaGris>
          </ContainerAuto>
        </>
      )}
      <Meter />
      {formatContent?.autorefresh && <Autorefresh timerRefresh={600} />}
      {formatContent?.enableFooter && <Footer />}
    </TemplateProvider>
  );
};

export default Service;